import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage, FormattedNumber } from 'react-intl';
import Field from 'redux-form/es/Field';
import InputField from 'components/Credit24/Core/Controls/InputField';
import InputToggleGroup from 'components/Credit24/Core/Controls/InputToggleGroup';
import { getCurrencyCode } from 'utils/helpers';

const propTypes = {
  incomeFrequencies: PropTypes.array.isRequired,
  otherExpensesFieldsDescriptor: PropTypes.array.isRequired,
  totalLivingExpenses: PropTypes.string,
};

const UpgradeExpensesAU = (props) => (
  <div className="loan-form__step-body">
    <h3 className="loan-form__step-subtitle">
      <FormattedHTMLMessage id="expenses.subtitle" />
    </h3>
    <div className="grid">
      <div className="grid__item one-half palm-one-whole">
        <Field
          title={<FormattedMessage id="expenses.housingCosts.title" />}
          name="housingCosts"
          component={InputField}
          prefix="$"
          useDigitsGrouping
          isFullWidth
        />
      </div>
      <div className="grid__item one-half palm-one-whole">
        <InputToggleGroup
          name="housingCostsFrequency"
          list={props.incomeFrequencies}
        />
      </div>
    </div>
    <div className="living-expenses">
      <div className="grid">
        <div className="grid__item one-whole">
          <dl className="living-expenses__total">
            <dt className="living-expenses__total-title">
              <FormattedMessage id="expenses.calculator.title.upgrade" />
            </dt>
            <dd className="living-expenses__total-details">
              <FormattedNumber
                minimumFractionDigits={0}
                maximumFractionDigits={0}
                currency={getCurrencyCode()}
                style="currency"
                value={Number(props.totalLivingExpenses) || 0}
              />
            </dd>
          </dl>
        </div>
        {props.otherExpensesFieldsDescriptor.map(({ name, hasHint }) => (
          <div className="grid__item one-half palm-one-whole" key={name}>
            <Field
              title={<FormattedMessage id={`expenses.${name}.title`} />}
              hintConfig={hasHint ? { titleKey: `expenses.${name}.hint` } : null}
              name={name}
              component={InputField}
              prefix="$"
              useDigitsGrouping
              isFullWidth
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

UpgradeExpensesAU.propTypes = propTypes;

export default UpgradeExpensesAU;
